export default "/images/vendor/flag-icons/flags/1x1/je.svg?915429967b8cf34fda008c827d5ee9f9";